import React, { useContext, useState, useEffect } from 'react';
import CardContainer from '@components/redesign/CardContainer';
import ButtonWrapper from '@v2/components/GDS/Button';
import KpiGrid from '@components/redesign/KpiGrid';
import KpiTile from '@components/redesign/KpiTile';
import { KpiData } from '@components/redesign/KpiTile/types';
import KpiDefinitionData from '../../../../../service/KpiDefinitionData';
import { FilterContext } from '@components/FilterBar/FilterProvider';
import ReachDetailsModal from './ReachDetailsModal';
import { useDynamicGraphQLQuery } from '@hooks/useDynamicGraphQLQuery';
import noOfSites from '@v2/kpis/mfg/ipc/valueRealization/noOfSites';
import noOfDepartments from '@v2/kpis/mfg/ipc/valueRealization/noOfDepartments';
import noOfTubes from '@v2/kpis/mfg/ipc/valueRealization/noOfTubes';
import { ipcReachMetricsFilters } from '@constants/Constants';

interface ReachScorecardProps {
  showTableView?: boolean;
}

const ReachScorecard: React.FC<ReachScorecardProps> = ({
  showTableView = true,
}) => {
  const { selectedProduct, selectedPlant } = useContext(FilterContext);
  const [showTableModal, setShowTableModal] = useState(false);
  const [overViewConfig, setOverViewConfig] = useState<KpiData[]>([]);

  const { data, isLoading } = useDynamicGraphQLQuery('getIPCReachMetrics', {
    filter: ipcReachMetricsFilters[0].value,
    siteId: selectedPlant?.id,
  });

  const generateScoreCardItems = (data: any) => {
    const items = [
      noOfSites.handler(data),
      noOfDepartments.handler(data),
      noOfTubes.handler(data),
    ];
    return items;
  };

  useEffect(() => {
    if (data?.getIPCReachMetrics?.data) {
      setOverViewConfig(
        generateScoreCardItems({ ...data.getIPCReachMetrics.data })
      );
    }
  }, [data, isLoading]);

  const toggleModal = () => setShowTableModal(!showTableModal);

  const viewTableButton = showTableView ? (
    <ButtonWrapper
      onClick={toggleModal}
      variant="secondary"
      text="View Table"
      size="medium"
    />
  ) : null;

  const headerControls = [viewTableButton];

  return (
    <>
      <CardContainer
        title="Reach"
        headerControls={headerControls}
        isAccordion={false}
        showInfoIcon={true}
        titleSubText={'*Applicable at Global level only'}
        dataDefinitions={{
          sections:
            KpiDefinitionData[selectedProduct?.productId]?.valueCreation
              ?.scoreCard ?? [],
        }}
        isLoading={isLoading}
      >
        <KpiGrid
          columnsDesktop={3}
          columnsTablet={2}
          columnsMobile={2}
          showHDividerMobile={false}
        >
          {overViewConfig.map((item, index) => (
            <KpiTile key={index} data={item} />
          ))}
        </KpiGrid>
      </CardContainer>
      <ReachDetailsModal
        showModal={showTableModal}
        onCloseModal={toggleModal}
      />
    </>
  );
};

export default ReachScorecard;
